import { useTranslation } from 'next-i18next';
import styles from './HowItWorks.module.scss';
import Image from 'next/dist/client/image';

const HowItWorks = () => {
  const { t } = useTranslation("olympiad")
  
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>
        {t("how-it-works")}
      </h2>
      <figure className={styles.figure}>
        <Image
          src="/img/olympiad/how-it-works.png"
          alt={t("how-it-works")}
          width={1446}
          height={765}
          layout='intrinsic'
        />
      </figure>
    </section>
  )
}

export default HowItWorks;